var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cp-legal"},[_c('div',{staticClass:"container h-100"},[_c('div',{staticClass:"row h-100 align-items-center"},[_c('div',{staticClass:"col-12 col-md-9 col-lg-8"},[_c('div',{staticClass:"legal-msg"},[_vm._v("Powered by SecurePlatformTech, "+_vm._s(_vm.year))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }